'use client'

import { Button, Container, Dialog, Spacer, Text, Validation } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  onConfirm: () => void
  onClose: () => void
  isVisible: boolean
  isLoading?: boolean
  title: string
  body: string
  confirmCtaText: string
  cancelCtaText: string
  showGeneralError?: boolean
  confirmCtaStyle?: React.ComponentProps<typeof Button>['styling']
  cancelCtaStyle?: React.ComponentProps<typeof Button>['styling']
  confirmCtaTheme?: React.ComponentProps<typeof Button>['theme']
  cancelCtaTheme?: React.ComponentProps<typeof Button>['theme']
}

const ConfirmationModal = ({
  onConfirm,
  onClose,
  isVisible,
  isLoading,
  title,
  body,
  confirmCtaText,
  cancelCtaText,
  showGeneralError,
  confirmCtaStyle = Button.Styling.Filled,
  cancelCtaStyle = Button.Styling.Flat,
  confirmCtaTheme = 'primary',
  cancelCtaTheme = 'primary',
}: Props) => {
  const errorTranslate = useTranslate('error_state')

  const handleConfirmClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (isLoading) {
      event.preventDefault()

      return
    }

    onConfirm()
  }

  return (
    <Dialog show={isVisible}>
      <Container>
        <Text
          as="h1"
          text={title}
          type={Text.Type.Heading}
          alignment={Text.Alignment.Center}
          width={Text.Width.Parent}
        />
        <Spacer size={Spacer.Size.XLarge} />
        <Text as="span" text={body} />
      </Container>
      {showGeneralError && (
        <>
          <Spacer size={Spacer.Size.XLarge} />
          {showGeneralError && <Validation text={errorTranslate('title')} theme="warning" />}
          <Spacer size={Spacer.Size.Small} />
        </>
      )}
      <Container>
        <Button
          text={confirmCtaText}
          styling={confirmCtaStyle}
          theme={confirmCtaTheme}
          onClick={handleConfirmClick}
          isLoading={isLoading}
        />
        <Spacer size={Spacer.Size.Medium} />
        <Button
          text={cancelCtaText}
          styling={cancelCtaStyle}
          theme={cancelCtaTheme}
          onClick={onClose}
        />
      </Container>
    </Dialog>
  )
}

export default ConfirmationModal
